import { styled } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import theme from "../constants/theme";

export default styled(Typography)({
  backgroundColor: theme.palette.secondary.light,
  borderRadius: 4,
  color: theme.palette.primary.main,
  padding: theme.spacing(2),
  fontSize: 14,
  margin: theme.spacing(3, 0, 1, 0),
  textAlign: "center",
});
